import React, { FC } from "react";

const User: FC = () => {
    return (
        <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.90741 0C10.0772 0 11.1991 0.465023 12.0263 1.29277C12.8534 2.12052 13.3181 3.24318 13.3181 4.41379C13.3181 5.5844 12.8534 6.70707 12.0263 7.53482C11.1991 8.36256 10.0772 8.82759 8.90741 8.82759C7.73761 8.82759 6.61572 8.36256 5.78855 7.53482C4.96137 6.70707 4.49667 5.5844 4.49667 4.41379C4.49667 3.24318 4.96137 2.12052 5.78855 1.29277C6.61572 0.465023 7.73761 0 8.90741 0ZM8.90741 11.0345C13.7813 11.0345 17.7289 13.0097 17.7289 15.4483V17.6552H0.0859375V15.4483C0.0859375 13.0097 4.03355 11.0345 8.90741 11.0345Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default React.memo(User);
